<template>
    <!-- CheckBox 유형 Sub Component-->
    <df-checkbox v-if="sub_type == 'checkbox'"
                 :ref="'my_sub_' + item.sub_code"
                 v-bind="item"
                 :previous="previous"
                 :preview="preview"
                 :is_disabled_by_parent="is_disabled_by_parent"
                 :audit_mode="audit_mode"
                 :is_final_sub_component="is_final_sub_component"
                 :print_mode="print_mode"
                 :no_answers="no_answers"
                 :view_pipe_line="view_pipe_line"
                 :skip_info="skip_info"
                 :is_edit_page="is_edit_page"
                 :last_save_state="last_save_state"
                 @update-parent-contents="handleUpdate"
                 @update-sub-data-contents="handleSubDataContents"
                 @update-pipeline="handleUpdatePipeline"
                 @sub-load-finished="handleSubLoadFinished"
                 @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-checkbox>

    <!-- Table 유형 Sub Component -->
    <df-table v-else-if="sub_type === 'table'"
              :ref="`my_sub_${item.sub_code}`"
              v-bind="item"
              :previous="previous"
              :preview="preview"
              :is_disabled_by_parent="is_disabled_by_parent"
              :audit_mode="audit_mode"
              :is_final_sub_component="is_final_sub_component"
              :print_mode="print_mode"
              :no_answers="no_answers"
              :view_pipe_line="view_pipe_line"
              :skip_info="skip_info"
              :is_edit_page="is_edit_page"
              :last_save_state="last_save_state"
              @update-parent-contents="handleUpdate"
              @update-sub-data-contents="handleSubDataContents"
              @update-pipeline="handleUpdatePipeline"
              @sub-load-finished="handleSubLoadFinished"
              @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-table>

    <!-- Radio 유형 Sub Component -->
    <df-radio v-else-if="sub_type == 'radio'"
              :ref="'my_sub_' + item.sub_code"
              v-bind="item"
              :previous="previous"
              :preview="preview"
              :audit_mode="audit_mode"
              :is_disabled_by_parent="is_disabled_by_parent"
              :is_final_sub_component="is_final_sub_component"
              :print_mode="print_mode"
              :no_answers="no_answers"
              :view_pipe_line="view_pipe_line"
              :skip_info="skip_info"
              :is_edit_page="is_edit_page"
              :last_save_state="last_save_state"
              @update-parent-contents="handleUpdate"
              @update-sub-data-contents="handleSubDataContents"
              @update-pipeline="handleUpdatePipeline"
              @sub-load-finished="handleSubLoadFinished"
              @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-radio>

    <!-- file_URL2 유형 Sub Component -->
    <df-file-url2 v-else-if="sub_type == 'file_URL2'"
                  :ref="'my_sub_' + item.sub_code"
                  v-bind="item"
                  :previous="previous"
                  :preview="preview"
                  :audit_mode="audit_mode"
                  :is_disabled_by_parent="is_disabled_by_parent"
                  :is_final_sub_component="is_final_sub_component"
                  :print_mode="print_mode"
                  :no_answers="no_answers"
                  :view_pipe_line="view_pipe_line"
                  :skip_info="skip_info"
                  :is_edit_page="is_edit_page"
                  :last_save_state="last_save_state"
                  @update-parent-contents="handleUpdate"
                  @update-sub-data-contents="handleSubDataContents"
                  @update-pipeline="handleUpdatePipeline"
                  @sub-load-finished="handleSubLoadFinished"
                  @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-file-url2>

    <!-- input_text 유형 Sub Component -->
    <df-input-text v-else-if="sub_type == 'input_text'"
                   :ref="'my_sub_' + item.sub_code"
                   v-bind="item"
                   :previous="previous"
                   :preview="preview"
                   :audit_mode="audit_mode"
                   :is_disabled_by_parent="is_disabled_by_parent"
                   :is_final_sub_component="is_final_sub_component"
                   :print_mode="print_mode"
                   :no_answers="no_answers"
                   :view_pipe_line="view_pipe_line"
                   :skip_info="skip_info"
                   :is_edit_page="is_edit_page"
                   :last_save_state="last_save_state"
                   @update-parent-contents="handleUpdate"
                   @update-sub-data-contents="handleSubDataContents"
                   @update-pipeline="handleUpdatePipeline"
                   @sub-load-finished="handleSubLoadFinished"
                   @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-input-text>

    <!-- input_number 유형 Sub Component -->
    <df-input-number v-else-if="sub_type == 'input_number'"
                     :ref="'my_sub_' + item.sub_code"
                     v-bind="item"
                     :previous="previous"
                     :preview="preview"
                     :audit_mode="audit_mode"
                     :is_final_sub_component="is_final_sub_component"
                     :is_disabled_by_parent="is_disabled_by_parent"
                     :print_mode="print_mode"
                     :no_answers="no_answers"
                     :view_pipe_line="view_pipe_line"
                     :skip_info="skip_info"
                     :is_edit_page="is_edit_page"
                     :last_save_state="last_save_state"
                     @update-parent-contents="handleUpdate"
                     @update-sub-data-contents="handleSubDataContents"
                     @update-pipeline="handleUpdatePipeline"
                     @sub-load-finished="handleSubLoadFinished"
                     @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-input-number>

    <!-- textbox 유형 Sub Component -->
    <df-textbox v-else-if="sub_type == 'textbox'"
                :ref="'my_sub_' + item.sub_code"
                v-bind="item"
                :previous="previous"
                :preview="preview"
                :audit_mode="audit_mode"
                :is_final_sub_component="is_final_sub_component"
                :is_disabled_by_parent="is_disabled_by_parent"
                :print_mode="print_mode"
                :no_answers="no_answers"
                :view_pipe_line="view_pipe_line"
                :skip_info="skip_info"
                :is_edit_page="is_edit_page"
                :last_save_state="last_save_state"
                @update-parent-contents="handleUpdate"
                @update-sub-data-contents="handleSubDataContents"
                @update-pipeline="handleUpdatePipeline"
                @sub-load-finished="handleSubLoadFinished"
                @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-textbox>

    <!-- materiality 유형 Sub Component -->
    <df-materiality v-else-if="sub_type == 'materiality'"
                    :ref="'my_sub_' + item.sub_code"
                    v-bind="item"
                    :previous="previous"
                    :preview="preview"
                    :audit_mode="audit_mode"
                    :is_disabled_by_parent="is_disabled_by_parent"
                    :is_final_sub_component="is_final_sub_component"
                    :print_mode="print_mode"
                    :no_answers="no_answers"
                    :view_pipe_line="view_pipe_line"
                    :skip_info="skip_info"
                    :is_edit_page="is_edit_page"
                    :last_save_state="last_save_state"
                    @update-parent-contents="handleUpdate"
                    @update-sub-data-contents="handleSubDataContents"
                    @update-pipeline="handleUpdatePipeline"
                    @sub-load-finished="handleSubLoadFinished"
                    @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-materiality>

    <!-- priority 유형 Sub Component -->
    <df-priority v-else-if="sub_type == 'priority'" 
                 :ref="'my_sub_' + item.sub_code"
                 v-bind="item"
                 :previous="previous"
                 :preview="preview"
                 :audit_mode="audit_mode"
                 :is_final_sub_component="is_final_sub_component"
                 :is_disabled_by_parent="is_disabled_by_parent"
                 :print_mode="print_mode"
                 :no_answers="no_answers"
                 :view_pipe_line="view_pipe_line"
                 :skip_info="skip_info"
                 :is_edit_page="is_edit_page"
                 :last_save_state="last_save_state"
                 @update-parent-contents="handleUpdate"
                 @update-sub-data-contents="handleSubDataContents"
                 @update-pipeline="handleUpdatePipeline"
                 @sub-load-finished="handleSubLoadFinished"
                 @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-priority>

    <!-- guide_text 유형 Sub Component -->
    <df-guide-text v-else-if="sub_type == 'guide_text'"
                   :ref="'my_sub_' + item.sub_code"
                   v-bind="item"
                   :previous="previous"
                   :preview="preview"
                   :audit_mode="audit_mode"
                   :is_disabled_by_parent="is_disabled_by_parent"
                   :is_final_sub_component="is_final_sub_component"
                   :print_mode="print_mode"
                   :no_answers="no_answers"
                   :view_pipe_line="view_pipe_line"
                   :skip_info="skip_info"
                   :is_edit_page="is_edit_page"
                   :last_save_state="last_save_state"
                   @update-parent-contents="handleUpdate"
                   @update-sub-data-contents="handleSubDataContents"
                   @update-pipeline="handleUpdatePipeline"
                   @sub-load-finished="handleSubLoadFinished"
                   @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-guide-text>
    <df-guide-text2 v-else-if="sub_type == 'guide_text2'"
                   :ref="'my_sub_' + item.sub_code"
                   v-bind="item"
                   :previous="previous"
                   :preview="preview"
                   :audit_mode="audit_mode"
                   :is_disabled_by_parent="is_disabled_by_parent"
                   :is_final_sub_component="is_final_sub_component"
                   :print_mode="print_mode"
                   :no_answers="no_answers"
                   :view_pipe_line="view_pipe_line"
                   :skip_info="skip_info"
                   :is_edit_page="is_edit_page"
                   :last_save_state="last_save_state"
                   @update-parent-contents="handleUpdate"
                   @update-sub-data-contents="handleSubDataContents"
                   @update-pipeline="handleUpdatePipeline"
                   @sub-load-finished="handleSubLoadFinished"
                   @update-sub-for-print="_updated_subs => $emit('update-sub-for-print', _updated_subs)"
    >
    </df-guide-text2>



    <!-- 기타 -->
    <!-- <div v-else>
        <p> 타입 {{ item.sub_type }} </p>
        <p> 내용 {{ item }} </p>
    </div> -->

    <!-- Depreciated 
    <div fluid v-else-if="sub_type == 'radio_group'"><df-radio-group :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-radio-group></div>
    <div v-else-if="sub_type == 'file'" class="mb-5"><df-file :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-file></div
    <div v-else-if="sub_type == 'URL'" class="mb-5"><df-url :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-url></div>
    <div v-else-if="sub_type == 'file_URL'" class="mb-5"><df-file-url :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-file-url></div>
    <div v-else-if="sub_type == 'container_radio'"><df-container-radio :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-container-radio></div>
    <div v-else-if="sub_type == 'rich_textbox'"><df-rich-textbox :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-rich-textbox></div>
    <div v-else-if="sub_type == 'editable_table'"><df-editable-table :is_disabled_by_parent="is_disabled_by_parent" v-bind="item"></df-editable-table></div>
    -->
</template>

<script>
import DFCheckBox from '@core_components/client/components/subs/DFCheckBox.vue'
import DFFile_URL2 from '@core_components/client/components/subs/DFFile_URL2.vue'
import DFInputNumber from '@core_components/client/components/subs/DFInputNumber.vue'
import DFInputText from '@core_components/client/components/subs/DFInputText.vue'
import DFRadio from '@core_components/client/components/subs/DFRadio.vue'
import DFTable from '@core_components/client/components/subs/DFTable.vue'
import DFTextbox from '@core_components/client/components/subs/DFTextbox.vue'
import DFMateriality from '@core_components/client/components/subs/DFMateriality.vue'
import DFPriority from '@core_components/client/components/subs/DFPriority.vue'
import DFGuideText from '@core_components/client/components/subs/DFGuideText.vue'
import DfGuideText2 from "@core/components/client/components/subs/DFGuideText2.vue";
// import DFEditableTable from './DFEditableTable'
//import DFContainerRadio from './DFContainerRadio'
//import DFRichTextbox from './DFRichTextbox'
//import DFFile_URL from './DFFile_URL'
//import DFURL from './DFURL'
//import DFRadioGroup from './DFRadioGroup'
//import DFFile from './DFFile'

export default {
    name: 'sub-component',
    props: {
        item: {
            type: Object
        },
        sub_type: {
            type: String
        },
        is_disabled_by_parent: {
            type: Boolean
        },
        preview: {
            type: Boolean
        },
        previous: {
            type: Boolean
        },
        audit_mode: {
            type: Boolean
        },
        is_final_sub_component: {
            type: Boolean,
            default: false
        },
        print_mode: {
            type: Boolean,
            default: false
        },
        no_answers: {
            type: Boolean,
            default: false
        },
        view_pipe_line: {
            type: Boolean,
            default: true
        },
        skip_info: {
            type: Boolean,
            default: false
        },
        is_edit_page: {
            type: Boolean,
            default: false
        },
        last_save_state:{
            type: String,
            default: 'not_saved'
        }
    },
    components: {
        DfGuideText2,
        'df-checkbox': DFCheckBox,
        'df-file-url2': DFFile_URL2,
        'df-input-number': DFInputNumber,
        'df-input-text': DFInputText,
        'df-radio': DFRadio,
        'df-table': DFTable,
        'df-textbox': DFTextbox,
        'df-materiality': DFMateriality,
        'df-priority': DFPriority,
        'df-guide-text': DFGuideText,
        //'df-container-radio': DFContainerRadio,
        //'df-rich-textbox': DFRichTextbox,
        //'df-url': DFURL,
        //'df-radio-group': DFRadioGroup,
        //'df-file': DFFile,
        //'df-file-url': DFFile_URL,
        //'df-editable-table': DFEditableTable,
    },
    data() {
        return {}
    },
    methods: {
        handleUpdate(sub_data_contents, sub_code) {
            this.$emit('update-parent-contents', sub_data_contents, sub_code)
        },
        handleSubDataContents(sub_data_contents, sub_code) {
            this.$emit('update-sub-data-contents', sub_data_contents, sub_code)
        },
        handleUpdatePipeline(last_save_state) {
            this.$emit('update-pipeline',last_save_state)
        },
        handleSubLoadFinished(loaded_sub_code) {
            this.$emit('sub-load-finished', loaded_sub_code)
        }
    },
}
</script>

<style>
</style>
